import type { TenantConfig } from '@/types/TenantConfig'

const burgundy = '#720f10'
const gold = '#ba9765'
const lightGold = '#f1eae0'
const darkBurgundy = '#f0b0c'

export const uskc: TenantConfig = {
  themeOptions: {
    primaryColor: burgundy,
    secondaryColor: burgundy,
    logoHeight: '120px',
    headerHeight: '140px',
    headerBottomBorder: '1px solid #D9D9D9',
    footerBackgroundColor: '#303642',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: '#F1F1F1',
    cartHeaderTextColor: '#222',
    dialog: {
      headerBackground: '#f1f1f1',
    },
    mobileFooter: {
      cartButtonBorder: '1px solid #767676',
      cartButtonIconColor: '#000000',
      textColor: '#222222',
      priceTextColor: '#222222',
    },
  },
  logo: 'assets/uskc/static/logo.png',
  teaserImageSize: {
    width: 145,
    height: 145,
  },
  componentOptions: {
    eventDetailRoute: {
      showVenue: true,
    },
    eventListingItem: {
      showVenue: true,
    },
    completedOrdersRoute: {
      completedImage: {
        mobile: 'assets/uskc/static/completed-photo.jpg',
        desktop: 'assets/uskc/static/completed-photo-wide.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-250px',
      },
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, sign up or continue as a guest',
        loginTitle: 'I am a USKC member',
        signupTitle: "I'm not a member – Sign me up!",
        guestTitle: 'Shop as a guest',
        guestButton: 'Shop as a guest',
        resendTicketsTitle: '',
        resendTicketsLink: 'Need your digital membership cards or tickets resent?',
      },
      checkoutRoute: {
        title: 'Pay for Your Order',
      },

      namedMembers: {
        roleTitles: {
          member: 'Your name as you would like it to appear on your membership card.',
        },
      },
      unnamedMembers: {
        label: 'How many {role_name} are in your household?',
      },
      memberRoleLabels: {
        'child-member': 'child member | children under 18',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Enjoy all that USKC has to offer:</p>

          <ul>
            <li>Great value</li>
            <li>Support Union Station</li>
            <li>Exclusive events</li>
            <li>Tax deductible</li>
          </ul>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can shop as a guest without having to register.</p>
      `,
    },
  ],
}
